module.exports = __webpack_public_path__ + "assets/images/project/indonesia-desktop.jpg?v=6597c8f0";